import { render, staticRenderFns } from "./TmsTable.vue?vue&type=template&id=63c699c7&scoped=true&"
import script from "./TmsTable.vue?vue&type=script&lang=ts&"
export * from "./TmsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TmsTable.vue?vue&type=style&index=0&id=63c699c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c699c7",
  null
  
)

export default component.exports